var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "card", attrs: { href: "#" } }, [
      _c("img", {
        staticClass: "card-img",
        attrs: { src: "/images/temp/promo_bg.png", alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card-img-overlay" }, [
        _c("div", [
          _c("p", { staticClass: "card-text" }, [
            _vm._v("\n        Lorem ipsum\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn btn-outline-warning link" }, [
            _vm._v("Zobacz więcej"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }